import { useNavigate } from "react-router-dom";
import "./style.css";

function PageHeader({
  titulo,
  subtitulo,
  abrirMenu,

  filtroData = false,
  dataInicio,
  dataFim,
  onDataInicioChange,
  onDataFimChange,

  botaoAdicionar = false,
  textoAdicionar = "Adicionar",
  onAdicionar,

  adicionarConteudo,

  children
}) {

  const navigate = useNavigate();

  return (

    <div className="page-header-wrapper">

      <div className="page-header-container">

        {/* HEADER */}

        <div className="page-header">

          <div className="page-header-left">

            <button
              className="btn-voltar"
              onClick={() => navigate("/principal")}
            >
              ←
            </button>

            <div className="page-header-title">
              <h2>{titulo}</h2>
              {subtitulo && <span>{subtitulo}</span>}
            </div>

          </div>

          <button
            className="btn-menu"
            onClick={abrirMenu}
          >
            ☰
          </button>

        </div>


        {(filtroData || botaoAdicionar || children) && (

          <div className="header-filtros">

            <div className="header-filtros-left">

              {filtroData && (

                <div className="filtro-periodo">

                  <input
                    type="date"
                    value={dataInicio}
                    onChange={(e) =>
                      onDataInicioChange && onDataInicioChange(e.target.value)
                    }
                  />

                  <input
                    type="date"
                    value={dataFim}
                    onChange={(e) =>
                      onDataFimChange && onDataFimChange(e.target.value)
                    }
                  />

                </div>

              )}

              {children}

            </div>


            <div className="header-filtros-right">

              {botaoAdicionar && (

                <div className="btn-add-wrapper">

                  <button
                    className="btn-add"
                    onClick={onAdicionar}
                  >
                    + {textoAdicionar}
                  </button>

                  {adicionarConteudo}

                </div>

              )}

            </div>

          </div>

        )}

      </div>

    </div>

  );
}

export default PageHeader;